import { HttpParams } from '@angular/common/http'
import { Params } from '@angular/router'

export class ApiUtils {
  public static buildQueryString(obj: {}): string {
    let query: string = ''

    Object.entries(obj).forEach(([key, value], index, arr) => {
      query += `${key}=${value}`
      if (index !== arr.length - 1) query += '&'
    })

    return query
  }

  private static appendObjectParams(httpParams: HttpParams, objectParams: Params): HttpParams {
    Object.keys(objectParams).forEach((key) => {
      const value = objectParams[key]
      if (Array.isArray(value)) {
        value.forEach((item) => {
          httpParams = httpParams.append(key, item)
        })
      } else if (value) {
        httpParams = httpParams.append(key, value.toString())
      }
    })
    return httpParams
  }
}
